import React, { useState } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ResultPdf from "./ResultPdf";

export default function ResultPdfDownloadButton({
  cycleImage,
  pressureImage,
  pressureMapImage,
  doctorMetricsImage,
  patientInfo,
  metrics = {},
  disabled = false,
  loading = false,
}) {
  const [pdfLoading, setPdfLoading] = useState(false);

  const handleDocumentLoad = () => {
    setPdfLoading(true);
  };

  const isDisabled = disabled || pdfLoading || loading;

  return (
    <PDFDownloadLink
      document={
        <ResultPdf
          doctorMetricsImage={doctorMetricsImage}
          cycleImage={cycleImage}
          pressureImage={pressureImage}
          pressureMapImage={pressureMapImage}
          metrics={metrics}
          patientInfo={patientInfo}
        />
      }
      fileName="gait_report.pdf"
      onLoad={handleDocumentLoad}
    >
      {({ loading: reactPdfLoading }) => (
        <Button
          disabled={isDisabled || reactPdfLoading}
          startIcon={
            (loading || pdfLoading || reactPdfLoading) ? <CircularProgress size={20} /> : <CloudDownloadIcon />
          }
          variant="contained"
          color="primary"
        >
          {loading ? "Preparing images..." : 
           pdfLoading || reactPdfLoading ? "Generating PDF..." : 
           "Download PDF"}
        </Button>
      )}
    </PDFDownloadLink>
  );
}
